import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss, { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface StickyFooterStyles {
    container?: InjectableCss;
}

interface StickyFooterProps {
    children: React.ReactNode;
    customStyles?: InjectableCss;
    marginLeft?: boolean;
}

const StickyFooter: React.FC<StickyFooterProps> = ({ children, customStyles, marginLeft }) => {
    const stickyFooterStyles = {
        container: {
            css: css`
                position: fixed;
                bottom: 0;
                width: 100%;
                margin-left: ${marginLeft ? "-15px" : 0};

                /* margin-right: -15px; */
                box-shadow: 0 -7px 18px 0 #0000001a;
                z-index: 1300;

                &::after {
                    content: "";
                    position: absolute;
                    top: -1px;
                    width: calc(100% - 30px);
                    margin-left: 15px;
                    margin-right: 15px;
                    border-top: 1px solid ${getColor("common.border")};
                }
            `,
        },
    };
    if (!React.Children.count(children)) {
        return null;
    }
    const [styles] = React.useState(() => mergeToNew(stickyFooterStyles.container, customStyles));

    return <StyledWrapper {...stickyFooterStyles.container}>{children}</StyledWrapper>;
};

export default StickyFooter;
